<template>
<div class="container-fluid">
    <div class="main-container">
        <div class="col-md-6">
            <div class="row mt-5">
                <p class="welcome">
                    Welcome! Choose your preferred option below to proceed!
                </p>
            </div>

           <router-link to="/escort">
                <div class="box d-flex flex-column">
                    <span>
                        <i class="fa fa-female"></i>
                        <strong>Model</strong>
                    </span>
                    <small class="text-white">I am a model/escort offering services</small>
                </div>
            </router-link>

            <router-link to="/guest">
                <div class="box d-flex flex-column">
                    <span>
                        <i class="fa fa-user"></i>
                        <strong>Guest</strong>
                    </span>
                    <small class="text-white">I am a client looking for models</small>
                </div>
            </router-link>
          
        </div>
        <div class="col-md-6">
            <div class="row right-box">
                <div class="col-md-6">
                    <img src="../../assets/banner.svg" alt="dating" width="430" class="dating">
                </div>
            </div>
        </div>
    </div>
   
     <!-- Signup Modal for lets play -->
    <div id="signup-letsplay" class="modal-window">
        <div class="row">
            <div class="col-md-2">
                <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                <br>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <p class="modal-logo">
                        <img src="logo.png" alt="lets play">
                    </p>
                    <h2>
                        Welcome!<br>
                        Tell us who are you?
                    </h2>
                    <div class="modal-box">
                        <img src="../../assets/google-icon.png" alt="Sign up with google"> &nbsp; Sign up with Google
                    </div>
                    <div class="modal-box">
                        <img src="../../assets/facebook.png" alt="Sign up with Facebook"> &nbsp; Sign up with Facebook
                    </div>
                    <div class="modal-box">
                       <router-link style="text-decoration: none; color: #5a6a77;" to="/sign-up"><img src="../../assets/phone.png" alt="Log in using mobile number"> &nbsp; Sign up using email</router-link>
                    </div>
                </div>
                <div class="row">
                    <p class="terms">
                        By signing up, you agree to our <span> Terms.</span> See how we use your data in our <span>Privacy Policy.</span>
                    </p>
                </div>
                
            </div>
            <div class="col-md-2">
                <div>
                    <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                  </div>
            </div>

        </div>
    </div>

    <!-- Signup Modal for lets date & hangout -->
    <div id="signup-letsdate-hangout" class="modal-window">
        <div class="row">
            <div class="col-md-2">
                <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                <br>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <p class="modal-logo">
                        <img src="logo.png" alt="lets play">
                    </p>
                    <h2>
                        Welcome!<br>
                        Tell us who are you?
                    </h2>
                    <div class="modal-box">
                        <img src="../../assets/google-icon.png" alt="Sign up with google"> &nbsp; Sign up with Google
                    </div>
                    <div class="modal-box">
                        <img src="../../assets/facebook.png" alt="Sign up with Facebook"> &nbsp; Sign up with Facebook
                    </div>
                    <div class="modal-box">
                       <router-link style="text-decoration: none; color: #5a6a77;" to="/sign-up"><img src="../../assets/phone.png" alt="Log in using mobile number"> &nbsp; Sign up using email</router-link>
                    </div>
                </div>
                <div class="row">
                    <p class="terms">
                        By signing up, you agree to our <span> Terms.</span> See how we use your data in our <span>Privacy Policy.</span>
                    </p>
                </div>
                
            </div>
            <div class="col-md-2">
                <div>
                    <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                  </div>
            </div>

        </div>
    </div>

    <!-- Signup Modal for lets marry -->
    <div id="signup-letsmarry" class="modal-window">
        <div class="row">
            <div class="col-md-2">
                <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                <br>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <p class="modal-logo">
                        <img src="logo.png" alt="lets play">
                    </p>
                    <h2>
                        Welcome!<br>
                        Tell us who are you?
                    </h2>
                    <div class="modal-box">
                        <img src="../../assets/google-icon.png" alt="Sign up with google"> &nbsp; Sign up with Google
                    </div>
                    <div class="modal-box">
                        <img src="../../assets/facebook.png" alt="Sign up with Facebook"> &nbsp; Sign up with Facebook
                    </div>
                    <div class="modal-box">
                       <router-link style="text-decoration: none; color: #5a6a77;" to="/signup"><img src="../../assets/phone.png" alt="Log in using mobile number"> &nbsp; Sign up using email</router-link>
                    </div>
                </div>
                <div class="row">
                    <p class="terms">
                        By signing up, you agree to our <span> Terms.</span> See how we use your data in our <span>Privacy Policy.</span>
                    </p>
                </div>
                
            </div>
            <div class="col-md-2">
                <div>
                    <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                  </div>
            </div>

        </div>
    </div>    

     <!-- Login Modal -->
     <div id="login" class="modal-window">
        <div class="row">
            <div class="col-md-2">
                <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                <br>
            </div>
            <div class="col-md-8">
                <div class="row">
                   
                    <p class="modal-logo">
                        <img src="logo.png" alt="letsplay">
                    </p>
                    <h2>
                        Login
                    </h2>
                    <p class="welcome">Welcome... Log into your account</p>
                    
                    <div class="row">
                        <label>Email</label>
                        <input type="text" placeholder="Your Email" class="login-modal-box" v-model="email">
                    </div>
                    <div class="row">
                        <label>Password</label>
                        <input type="password" placeholder="Your Password" class="login-modal-box" v-model="password">
                    </div>

                    <div class="row">
                        <!-- <button class="btn-login" type="submit" @click="login()">
                            <b v-if="loading">
                                    Login...
                            </b>
                            <b v-else>Login</b>
                            
                       </button> -->
                        <button class="btn-login" @click="login()" v-if="!loading"> Login </button>
                        <button class="btn-login" type="button" disabled v-if="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Login...
                        </button>
                    </div>

                    <div class="row">
                        <p class="forgot-password">
                            Forgot Password? <span><a href="#forgot-password">Click Here </a> </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div>
                    <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                  </div>
            </div>

        </div>
    </div>

    <!-- forgot password Modal -->
    <div id="forgot-password" class="modal-window">
        <div class="row">
            <div class="col-md-2">
                <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                <br>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <span class="modal-logo">
                        <img src="logo.png" alt="letsplay">
                    </span>
                    <h2>
                        Forgot Password
                    </h2>
                    <p class="welcome">Enter email to reset your password</p>
                    
                    <div class="row">
                        <label>Email address</label>
                        <input type="text" v-model="reset_email_address" placeholder="Your Email" class="login-modal-box">
                    </div>
                   
                    <div class="row">
                        <!-- <button class="btn-login" @click="reset()">
                            <b v-if="loading">
                                Submitting...
                                <i class="fa fa-spinner"></i>
                            </b>
                            <b v-else>Done</b>
                        </button> -->
                        <button class="btn-login" @click="reset()" v-if="!loading"> Submit </button>
                        <button class="btn-login" type="button" disabled v-if="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div>
                    <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                  </div>
            </div>

        </div>
    </div>

</div>

</template>

<script>

import swal from 'sweetalert2';
import Vue from 'vue'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import VueCountryCode from "vue-country-code";
//import axios from 'axios';

Vue.use(VueTelInput)
Vue.use(VueCountryCode)
export default {
     data: () => ({
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        phone_number: '',
        email_address: '',
        reset_email_address: '',
        user_password: '',
        title_designation: '',
        company_name: '',
        user_country: '',
        country_dial_code: 0,
        user_state: '',
        user_city: '',
        user_date: '',
        user_month: '',
        user_day: '',
        user_gender: '',
        notify_birthday: 1,
        previewImage: null,
        user_role: '',
        error_code:'',
        message:'',
        status:'',
        response: '',
        loading: false,

        user_id: '',

        signUp: true,
        signIn: false,
        cardIf: false,
       
        state: [
            {value: 'ABIA', text:'ABIA'},
            {value: 'ADAMAWA', text:'ADAMAWA'},
            {value: 'AKWA IBOM',text: 'AKWA IBOM'},
            {value: 'ANAMBRA', text: 'ANAMBRA'},
            {value: 'BAUCHI', text: 'BAUCHI'},
            {value: 'BAYELSA', text: 'BAYELSA'},
            {value: 'BENUE', text: 'BENUE'},
            {value: 'BORNO', text: 'BORNO'},
            {value: 'CROSS RIVER', text: 'CROSS RIVER'},
            {value: 'DELTA', text:'DELTA'},
            {value: 'EDO', text:'EDO'},
            {value: 'EBONYI', text: 'EBONYI'},
            {value: 'EKITI', text: 'EKITI'},
            {value: 'ENUGU', text: 'ENUGU'},
            {value: 'GOMBE', text: 'GOMBE'},
            {value: 'IMO', text: 'IMO'},
            {value: 'JIGAWA', text:'JIGAWA'},
            {value: 'KADUNA', text: 'KADUNA'},
            {value: 'KANO', text: 'KANO'},
            {value: 'KATSINA', text:'KATSINA'},
            {value: 'KEBBI', text: 'KEBBI'},
            {value: 'KOGI', text: 'KOGI'},
            {value: 'KWARA',  text: 'KWARA'},
            {value: 'LAGOS', text: 'LAGOS'},
            {value: 'NIGER', text: 'NIGER'},
            {value: 'OGUN', text: 'OGUN'},
            {value: 'ONDO', text:'ONDO'},
            {value: 'OSUN', text: 'OSUN'},
            {value: 'OYO', text: 'OYO'},
            {value: 'NASARAWA', text: 'NASARAWA'},
            {value: 'PLATEAU', text: 'PLATEAU'},
            {value: 'RIVERS', text: 'RIVERS'},
            {value: 'SOKOTO', text: 'SOKOTO'},
            {value: 'TARABA', text: 'TARABA'},
            {value: 'YOBE', text: 'YOBE'},
            {value: 'ZAMFARA', text: 'ZAMFARA'},
            {value: 'ABUJA', text:'ABUJA'},
           
        ],
      
    }),
    
    beforeMount(){
   
    },

    mounted(){
        localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
    },

    methods: {

        async reset() {

            if (!this.reset_email_address) {
            
                swal.fire({
                    icon: 'warning',
                    title: 'Error...',
                    width:450,
                    height:4,
                    text: 'Please enter your email address',
                })
                return;
            }

            try {
                
                this.loading = true;

                this.response = await this.$http.post('/reset', {
                    email: this.reset_email_address,
                });
            
                this.loading = false;
                
                if (!this.response.data.success) {

                    swal.fire({
                        icon: "error",
                        title: "Error",
                        width:450,
                        height:5,
                        text: this.response.data.message,
                    });
                
                    return;
                    
                }else{
                                                
                    swal.fire({
                        icon: "success",
                        title: "Success",
                        width:450,
                        height:5,
                        text: this.response.data.message,
                    });
                
                    return;
                }     
                
            } catch (err) {
                console.log(err);
}


},
    
        showText(){
            const input =  document.getElementById('show_text');
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                  document.getElementById('eye_close').style.display="none";
                  document.getElementById('eye_open').style.display="block";
                } else {
                input.setAttribute("type", "password");
                  document.getElementById('eye_close').style.display="block";
                  document.getElementById('eye_open').style.display="none";
                }
        },

        showSignIn() {
            document.getElementById("signInId").className = "Active";
            document.getElementById("signUpId").className = "signIn";
            this.signIn = true
            this.signUp = false
           // this.cardIf = false
        },
        showSignUp() {
            document.getElementById("signInId").className = "signIn";
            //document.getElementById("cardId").className = "signIn";
            document.getElementById("signUpId").className = "Active1";
            this.signIn = false
            //this.cardIf = false
            this.signUp = true
           
        },
        showCardIn() {
            document.getElementById("signInId").className = "signIn";
            document.getElementById("signUpId").className = "signIn";
            //document.getElementById("cardId").className = "Activex";
            this.signIn = true
            this.signUp = false
            //this.cardIf = true
        },

      
    },

}

</script>
<style lang="scss" scoped>
body {
    background: #0A070F !important;
}
.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 505px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
  
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}
.modal-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 52px;
    width: 380px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 50px;
    margin: 2%;
    cursor: pointer;
}
.login-modal-box {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 52px;
    gap: 311px;
    width: 496px;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    margin: 10px;
    color: #767475;
}
.btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
}
.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}
.forgot-password {

    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 23px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 25px;

    span > a {
        color: #D33E74;
        cursor: pointer;
        text-decoration: none;

    }
}

.container-fluid{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #0A070F;
    width: 100%;
}

.main-container{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: transparent;
        width: 100%;
        
        a{
            text-decoration: none;
            color: #D33E74;
        }
    
        .box {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px 53px;
            width: 430px;
            height: 60px;
            border: 1px solid #D33E74;
            border-radius: 8px;
            margin: 4%;
            cursor:pointer;
        }
       
        .box > a {
            text-decoration: none;
            color: #D33E74;
            font-size: 20px;
            font-weight: 600;
        }
        .box:hover {
            background: #D33E74;
            border: 1px solid #D33E74;
            border-radius: 8px;
            color: #fff;

            a{
                color: #fff !important;
            }
        }
        .welcome {
            width: 450px;
            margin-left:35px;
            margin-bottom: 50px;
            font-family: 'Metropolis';
            font-style: normal;
            font-weight: 400;
            font-size: 25px;
            line-height: 107.7%;
            color: #FFFFFF;
            text-align: justify;
        }
        p {
            height: 26px;
            font-family: 'Metropolis';
            font-style: normal;
            font-weight: 600;
            font-size: 24px;
            line-height: 107.7%;
            color: #D33E74;
            text-align: left;
        }
      
        .right-box {
            margin-top: 15%;

            img {
                background: transparent;
            }
        }
        .dating {
           margin-top: -40px
        }
        .marry{
            margin: 20px;
            margin-right: 30%;
        }
        .hangout{
            margin-right: 20%;
        }
}

@media screen and (max-width: 768px) {

    .modal-window {
        position: fixed;
        //background-color: rgba(255, 255, 255, 0.25);
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        transition: all 0.3s;
        &:target {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
        }
        & > div {
          width: 300px;
          height: 490px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          padding: 2em;
          border: 1px solid #2F2F2F;
          backdrop-filter: blur(13px);
          background: url(../../assets/modal_bg.png) no-repeat fixed center, #0A070F;
          box-sizing: border-box;
        }
        header {
          font-weight: bold;
        }
        h1 {
          font-size: 150%;
          margin: 0 0 15px;
        }
      }
      
      .modal-close {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
        display: none;
      }
      .modal-close-mobile {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
        display: block;
      }
      .modal-window {
        & > div {
            border-radius: 63px;
        }
      }
      .modal-logo > img {
        width: 90px;
        text-align: center;
    }
    h2 {
       
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 17px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        line-height: 190%;
        margin-top: 20px;
    
    }
    .modal-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 15px;
        gap: 19px;
        width: 360px;
        height: 46px;
        background: #FFFFFF;
        border-radius: 50px;
        margin: 2%;
        cursor: pointer;
        font-size: 12.5px;
    }
    .terms {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        text-align: center;
        color: #FFFFFF;
    
        span {
            color: #D33E74;
        }
    }

}

@media screen and (max-width: 768px) {
  
}

@media screen and (max-width: 768px) { 
    .container-fluid {
        background: #0A070F;
        margin-bottom: 0%;

        .header {

                .logo > img{
                    width: 80px !important;
                    height: 16px;
                }
                .login {
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 100px;
                    height: 40px;
                    background: #D33E74;
                    border-radius: 82px;
                    font-weight: bold;
                    color: #fff;
                    margin: 10px;

                }    
                .login > img{
                    height: 14px;
                }
            }        

    }
    .main-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background: #0A070F;
                margin-bottom: 0%;
                width: 100%;
            
                .box {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 4px 20px;
                    width: 100%;
                    height: 55px;
                    border: 1px solid #D33E74;
                    border-radius: 8px;
                    margin: 0%;
                    margin-top: 10px;
                }
                .welcome {
                    width: 100%;
                    margin-left:0px;
                    margin-bottom: 50px;
                    font-family: 'Metropolis';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 107.7%;
                    color: #FFFFFF;
                    text-align: justify;
                }
                p {
                    height: 26px;
                    font-family: 'Metropolis';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 50.7%;
                    color: #D33E74;
                    text-align: left;
                }
                .right-box {
                    margin-top: 0%;
                    img {
                        width: 100%;
                    }
                }
                .dating {
                    width: 100%;
                    margin-top: 30px;
                }
                .marry{
                    margin-right: 8%;
                    width: 100px !important;
                }
                .hangout{
                    margin-top: 20px;
                    width: 120px !important;
                }
            }
 }

</style>